import EfImg from '@elem/ui/ef-img';
import EcoVideo from 'eco-design/base/eco-video';
import styles from './index.module.scss';

interface SectionCardProps {
    title: string;
    desc?: string;
    lists?: any[];
    isVideo?: boolean;
    pc: string;
    h5: string;
}

export default function SectionCard({ title, desc, lists = [], pc, h5, isVideo }: SectionCardProps) {
    return (
        <div className={styles.SectionCard}>
            <div className="sectioncard-container">
                <div className="left">
                    {isVideo ? <EcoVideo pc={pc} h5={h5} autoPlay={true} loop={true} /> : <EfImg className="item-img" pc={pc} h5={h5} />}
                    <div className="mask"></div>
                </div>
                <div className="right">
                    <div className="sectioncard-title">{title}</div>
                    {desc && <div className="sectioncard-desc">{desc}</div>}
                    {lists.map((item, index) => (
                        <div className="sectioncard-lists" key={index}>
                            <div className="sectioncard-lists-title">
                                {item.title}
                                <div className="data-sup">{item.sup}</div>
                            </div>
                            <div className="sectioncard-lists-desc">{item.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
